import { useCallback } from 'react';
import { toast } from '@heroui/react';
import { MAX_WORKSPACE_PAGES } from '@/components/canvas/workspace/viewport/workspaceLimits';
import { useCanvasStore } from '@/components/canvas/store/canvas.store';

export function useAddPage() {
  const addPage = useCanvasStore((s) => s.addPage);
  return useCallback(() => {
    if (!addPage()) {
      toast.warning(`文档最多支持 ${MAX_WORKSPACE_PAGES} 页，已达上限`);
    }
  }, [addPage]);
}
